export enum MessengerEditorMode {
    NewMessage = 1, 
    Reply = 2, 
    Forward = 3, 
    ReplyAll= 4
}